// extracted by mini-css-extract-plugin
export var container = "_68-0";
export var error = "_68-9";
export var label = "_68-5";
export var light = "_68-6";
export var md = "_68-3";
export var sm = "_68-2";
export var thin = "_68-8";
export var thinBold = "_68-7";
export var vertical = "_68-4";
export var xs = "_68-1";